import React from 'react';
import ClientCarousel from '../home/client-carousel';
import TalkExpert from '../common/talk-expert';

const TechHeroVisionMultimodalAi = () => {
    return (
        <>
        <section className="hero home-hero technology-herosection relative aiml-hero-section llms-banner-video aiagent-banner">
            <div className="absolute inset-0 z-0">
                    <video playsInline autoPlay muted loop className="aimlvideo w-full h-full object-cover">
                        <source src="media/video-vision-multimodal-ai.mp4" type="video/mp4" />
                    </video>

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 pointer-events-none bg-video-gradient"></div>
                </div>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="row grid lg:grid-cols-12 hero-row gap-6 relative z-[1] h-full">
                    <div className="text-center lg:col-span-8 lg:col-start-3 grid">
                        <div className="inline-flex flex-col lg:items-center gap-4 hero-content justify-center h-full">
                            <p className="self-center mb-0 font-semibold text-white text-sm aiml-chip">
                                AI/ML Development Services
                            </p>
                            <h1 className="mb-0 text-white">
                                Build Intelligence That Sees:<br></br><span className="gradient-text">Vision AI & Multimodal AI</span>
                            </h1>
                            
                            <TalkExpert />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <ClientCarousel />
        </>
    );
};

export default TechHeroVisionMultimodalAi;
